
<div class="Section Credentials">
    <div class="Col">
        <img
            src="@/assets/svg/shield-check-fill.svg"
            alt="Staatliche Anerkennung - TaxiFusion erfüllt alle behördlichen Anforderungen"
            svg-inline
        />
        <h4>Staatlich Anerkannt</h4>
        <p>
            Wir erfüllen stets die aktuellen Voraussetzungen der wichtigsten Behörden der
            Taxibranche!
        </p>
    </div>
    <div class="Col">
        <img
            src="@/assets/svg/safe-2-fill.svg"
            alt="Datensicherheit - Sichere Datenspeicherung seit 2017"
            svg-inline
        />
        <h4>Aktuelle Sicherheit</h4>
        <p>
            Seit 2017 sind wir an Ihrer Seite und bieten Ihnen eine entsprechende Lösung zur
            Datenspeicherung für Ihr Fiskaltaxameter an.
        </p>
    </div>
    <div class="Col">
        <img
            src="@/assets/svg/cloud-fill.svg"
            alt="Cloud-Zugänglichkeit - TaxiFusion überall verwalten auf PC, Smartphone und Tablet"
            svg-inline
        />
        <h4>Überall zugreifen</h4>
        <p>
            Unsere webbasierte Software ermöglicht es Ihnen, Ihr Unternehmen von überall aus zu
            verwalten. Auf dem PC, Smartphone oder Tablet.
        </p>
    </div>
</div>
